export const PRIMARY_COLOR = '#82ca9d'
export const PRIMARY_COLOR_LIGHT = '#bbf0cf'
export const SECONDARY_COLOR = '#8884d8'

export const GRAPH_COLOR_1 = '#82ca9d'
export const GRAPH_COLOR_2 = '#8884d8'
export const GRAPH_COLOR_3 = '#eaf03a'
export const SECONDARY_COLOR_LIGHT = '#cdcbf7'
export const IOS_COLOR = '#0088FE'
export const ANDROID_COLOR = '#a4c639'
export const GRAY = '#999999'
